/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { VerifyAdminCreationAccessResponse, VerifyAdminCreationAccessVars } from '../openapi-types.gen.js';

export type { VerifyAdminCreationAccessResponse, VerifyAdminCreationAccessVars } from '../openapi-types.gen.js';

export const useVerifyAdminCreationAccess = createMutationHook<VerifyAdminCreationAccessVars, VerifyAdminCreationAccessResponse, unknown>({
  specName: 'useVerifyAdminCreationAccess',
  path: '/v1/admin/creation-access',
  method: 'POST',
  resolveUrl: (vars: VerifyAdminCreationAccessVars) => `/v1/admin/creation-access`,
  buildBody: (vars: VerifyAdminCreationAccessVars) => ({ turnkeySessionJwt: vars.turnkeySessionJwt, payerAddress: vars.payerAddress, user: vars.user, wallet: vars.wallet }),
  parseResponse: (raw: unknown): VerifyAdminCreationAccessResponse => raw as VerifyAdminCreationAccessResponse,
  
  
  
});
